<template>
  <div class="page-donation">
    <PageContainer :banner="false">
      <ClientOnly>
        <DonationsShow :id="id" />
      </ClientOnly>
    </PageContainer>
  </div>
</template>

<script>
import page from '@/mixins/page'

import DonationsShow from '@/components/donations/DonationsShow'
import PageContainer from '@/components/PageContainer'
import ClientOnly from '@/components/ClientOnly'

export default {
  name: 'Donation',

  mixins: [page],

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  components: {
    PageContainer,
    DonationsShow,
    ClientOnly
  }
}
</script>

<style lang="sass" scoped>
.page-donation
</style>
